import { render, staticRenderFns } from "./DataTableInventoryListEquipment.vue?vue&type=template&id=58895689&"
import script from "./DataTableInventoryListEquipment.vue?vue&type=script&lang=js&"
export * from "./DataTableInventoryListEquipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports